import { memo } from 'react';
const SvgCloudRain = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="cloud-rain_svg__feather cloud-rain_svg__feather-cloud-rain"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16 13v8M8 13v8M12 15v8M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25" />
  </svg>
);
const Memo = memo(SvgCloudRain);
export default Memo;
